// extracted by mini-css-extract-plugin
export var badge = "_i1-2";
export var detailsPanel = "_i1-0";
export var resultRow = "_i1-1";